import { useDispatch, useSelector } from "react-redux";
import { filterToggled } from "../../../features/sortFilter/sortFilterSlice";

export default function Filter() {
  const dispatch = useDispatch();
  const { isSaved } = useSelector(state => state.sortFilter);

  const handleSelect = (value)=>{
    dispatch(filterToggled(value))
  }

  return (
    <div className="sidebar-content">
      <h4>Filter</h4>
      <div className="radio-group">
        <div>
          <input onChange={()=>handleSelect(false)} checked={!isSaved} type="radio" name="filter" id="lws-all" className="radio" />
          <label htmlFor="lws-all">All</label>
        </div>
        <div>
          <input onChange={()=>handleSelect(true)} checked={isSaved} type="radio" name="filter" id="lws-saved" className="radio" />
          <label htmlFor="lws-saved">Saved</label>
        </div>
      </div>
    </div>
  )
}